export type CheckinPageIdType = (typeof CheckinPageIdType)[keyof typeof CheckinPageIdType];
export const CheckinPageIdType = {
  CHECKIN_PASSENGER_ADDITION: 'M021',
  CHECKIN_SEARCH: 'P010',
  CHECKIN_SELECT: 'P020',
  CHECKIN_PASSENGER_INPUT: 'P030',
  CHECKIN_SEATMAP: 'P040',
  CHECKIN_REVIEW: 'P050',
  CHECKIN_MYBOOKING: 'P010',
  CHECKIN_COMPLETED: 'P060',
  CHECKIN_WAITING_SEARCH: 'P010',
  CHECKIN_WAITING_NUMBER: 'P020',
  CHECKIN_STANDBY_REVIEW: 'P030',
  BOARDING_PASS_ISSUE: 'M020',
  DIGITAL_CERTIFICATE_REGISTRATION: 'M030',
  CHECKIN_STANDBY_COMPLETED: 'P040',
  CHECKIN_STANDBY_FLIGHT_AVAILABILITY: 'P020',
} as const;
